import mixpanel from "mixpanel-browser";

export const mixPanelConfig = ()=>{

    if (typeof window !== "undefined") {
        const token = process.env.FRONT_END_MIXPANEL_ACCESS_ID!;
        mixpanel.init(token, { 
        persistence: "localStorage" 
      });
      }
}